import getLoggedAtPlanUtil from '../get-logged-at'

function isLoggedPlanUtil (plan) {
  return !!getLoggedAtPlanUtil(plan)
}

export default isLoggedPlanUtil
